export const API_PARAMS = {
  IDENTITY_CURRENT: "admin/identity/token",
};
